import React from 'react';
import PropTypes from 'prop-types';

import Button from '@marvelapp/marvel-ui/button';

import { MARVELAPP_PROJECTS } from 'marketing-website/constants/urls';

export default function NavButton({ isLight, url, title, isLoggedIn }) {
  return (
    <a href={isLoggedIn ? MARVELAPP_PROJECTS : url}>
      <Button
        background={isLight ? 'white' : 'blue'}
        color={isLight ? 'slate' : 'white'}
        shape="rounded"
      >
        {isLoggedIn ? 'Go to dashboard' : title}
      </Button>
    </a>
  );
}

NavButton.propTypes = {
  isLight: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/NavButton/index.js